/**************************************************************************
Name:         jquery.paginatedTable.js
Description:  Window-based pagination controls
Date Created: 1/17/2014 by Kyle Brickman
Modified:
**************************************************************************/

( function( $ ){
	$.fn.paginatedTable = function( options )
	{
		var settings = $.extend({
			paginated            : true,
			sortable             : true,
			filters              : '',
			inlineFilters        : false,
			expertFilters        : '.expertFilter',
			actions              : [],
			windowID             : '',
			controlID            : '',
			color                : 'blue',
			maxPageDisplay       : 3,
			minPageDisplay       : 1,
			perPage              : [1,10,25,50,100,250],
			pagePositions        : ['upper','lower'],
			responsive           : true,
			admin                : false,
			subadmin             : false,
			noclick              : false,
			addMargin			 : true,
			multiTab 			 : false,
			addMessage 			 : false,
			excludeList			 : '',
			hasResults 			 : true,
			hasFilter			 : false,
			noResultsMsg 		 : '',
			lineNumber           : false,
			renderer             : function( data )
			{
				var table = $( this );
				var row   = $( '<tr />' );

				for( property in data )
				{
					var cell = $( '<td />' );
					cell.addClass( property );
					cell.html( data[property] );
					cell.appendTo( row );
				}

				row.appendTo( table );
			},
			onFilterComplete : function( )
			{
				/* GNDN */
			},
			onRenderComplete : function( )
			{
				/* GNDN */
			},
			onReset : function( )
			{
				/* GNDN */
			}
		}, options );

		return this.filter( 'table' ).each( function( index ){
			var getWindow = function( source )
			{
				var intervalCall = function( )
				{
					if( local.table.hasClass( 'network' ))
						return;

					clearInterval( intervalRef );
					var tempPadding = local.table.innerHeight( ) - local.header.outerHeight( ) - 1;
					local.responsive.addClass( 'hidden' );
					local.table.parent( ).removeClass( 'scrollable' );
					local.table.addClass( 'network' );
					$( 'tr', local.table ).css( 'height', '' );
					var oldRows = $( 'tr:not(.header)', local.table ).remove( );
					local.table.css( 'border-bottom', tempPadding + 'px solid transparent' );

					remoteCall(
						{ method : 'getWindow' },
						function( response )
						{
							var excludeList = local.settings.excludeList.toUpperCase( );
							local.settings.hasResults = true;
							highlightSort( response.data.sort );

							$( 'input[type="checkbox"], input[type="radio"]', local.settings.filters ).prop( 'checked', false );
							$( 'input[name]:not([type="checkbox"], [type="radio"]), select, textarea', local.settings.filters ).val( '' );

							var uppercaseKeys = {};
							for (var key in response.data.filters) {
								uppercaseKeys[key.toUpperCase()] = response.data.filters[key];
							}
							response.data.filters = uppercaseKeys;

							setTimeout( function( ) {
								$( $('input[name], select[name], textarea[name]', local.settings.filters).get().reverse() ).each( function( ){
									var element 	= $( this );
									var elementName = element.attr( 'name' ).toUpperCase( );
									var elementType = element.attr( 'type' );

									if( undefined != response.data.filters && undefined != response.data.filters[elementName])
									{
										if( (response.data.filters[elementName].length || parseInt( response.data.filters[elementName] )) && excludeList.indexOf( elementName ) < 0 ) local.settings.hasFilter = true;

										if( 'date' == elementType && moment && navigator.userAgent.match(/(iPad|iPhone|iPod|Android)/g))
										{
											element.val( moment( response.data.filters[elementName], ['MM-DD-YYYY','YYYY-MM-DD','MM/DD/YYYY'] ).format( 'YYYY-MM-DD' ));
										}
										else if( elementType === "hidden" && $( "input[data-delimited='" + elementName + "']" ).length ) 
										{
											element.val( response.data.filters[elementName] );
											var values = response.data.filters[elementName].toString().split( ',' );

											$( "input[data-delimited='" + elementName + "']" ).each(function() {
												var value = $( this ).val();
												$( this ).prop( "checked", values.indexOf( value ) > -1 );
											});
										}
										else if( undefined == elementType || ( 'checkbox' != elementType && 'radio' != elementType ))
										{

											if( element.val( ) != response.data.filters[elementName])
												element.val( response.data.filters[elementName] );
										}
										else 
										{
											element.prop( 'checked', -1 != String( response.data.filters[elementName] ).split( ',' ).indexOf( element.val( )));
										}
											

										if( elementType == 'hidden' && element.parent( ).hasClass( 'fayt' )) {
											var elementName = element.attr( 'name' );

											if( elementName.toLowerCase( ).indexOf( 'uuid' ) >= 0 ) {
												if( elementName.toLowerCase( ).indexOf( 'eventuuid' 	   ) >= 0 ) setTitle( element, element.val( ), 'event' 		   );
												if( elementName.toLowerCase( ).indexOf( 'organizationuuid' ) >= 0 ) setTitle( element, element.val( ), 'organization'  );
												if( elementName.toLowerCase( ).indexOf( 'contactuuid' 	   ) >= 0 ) setTitle( element, element.val( ), 'contact' 	   );
											} else
												element.siblings( $( 'input[type="text"]' )).val( element.val( ));
										}

										element.trigger( 'change' );

										// Blur sometimes fails for mobile devices
										try { element.trigger( 'blur' ); }
										catch (e) { }
									}
								});
							}, 50 );

							if( 'init' == source || 'setFilters' == source )
							{
								setTimeout( function( ) {
									local.settings.onFilterComplete.call( $( local.settings.filters ).get( 0 ));

									if( typeof Placeholders !== 'undefined' )
									{
										$( 'input:not([type="radio"],[type="checkbox"])' ).each( function( ){
											Placeholders.disable( this );
											Placeholders.enable(  this );
										});
									}
								}, 50 );
							}

							$.each( local.pagination.positions, function( posIndex, posValue ){
								if( local.settings.admin )
									local.pagination[posValue].label.text( response.data.perPage );

								local.pagination[posValue].select.val( response.data.perPage );

								local.pagination[posValue].first.detach( );
								local.pagination[posValue].last.detach( );

								// Determination of link state
								$( 'a', local.pagination[posValue].all ).attr( 'data-remove', true );

								var firstToShow = parseInt(response.data.page) - local.settings['none' != local.pagination[posValue].select.css( 'display' ) ? 'maxPageDisplay' : 'minPageDisplay'];
								var  lastToShow = parseInt(response.data.page) + local.settings['none' != local.pagination[posValue].select.css( 'display' ) ? 'maxPageDisplay' : 'minPageDisplay'];

								if( 1 == response.data.page )
									local.pagination[posValue].first.attr( 'data-active', true );

								if( response.data.pages == response.data.page )
									local.pagination[posValue].last.attr( 'data-active', true );

								for( var i = 1; i <= response.data.pages; i++ )
								{
									var pageLink = $( 'a[href="#' + i + '"]', local.pagination[posValue].all );

									if( !pageLink.length )
									{
										pageLink = $( '<a />' );
										pageLink.attr( 'title', 'Go to page ' + i );
										pageLink.attr( 'href', '#' + i );
										pageLink.text( i );

										pageLink.addClass( 'inactive' );

										pageLink.appendTo( $( 'div:not(.rollup,.attention,.showHide,.rollupBlock,.recordCount,.column)', local.pagination[posValue].all ));
									}

									if( i < firstToShow || i > lastToShow )
									{
										pageLink.attr( 'data-hide', true );

										if( 1 == i )
										{
											pageLink.removeAttr( 'data-hide' );

											if( i != firstToShow - 1 )
												pageLink.attr( 'data-ellipse-right', true );
										}

										if( response.data.pages == i )
										{
											pageLink.removeAttr( 'data-hide' );

											if( i != lastToShow + 1 )
												pageLink.attr( 'data-ellipse-left', true );
										}
									}
									else
										pageLink.attr( 'data-show', true );

									if( i == response.data.page )
										pageLink.attr( 'data-active', true );

									pageLink.removeAttr( 'data-remove' );
								}

								local.pagination[posValue].first.insertAfter( local.pagination[posValue].perPage );
								local.pagination[posValue].last.appendTo( $( 'div:not(.rollup,.attention,.showHide,.rollupBlock,.recordCount,.column)', local.pagination[posValue].all ));

								$( 'div.recordCount', local.pagination[posValue].all ).remove( );

								//Add record count
								if( response.data.recordCount && local.settings.admin )
								{
									var recordCount = $( '<div />' );
									recordCount.text( response.data.recordCount + ' Found' );

									recordCount.addClass( 'recordCount' );

									recordCount.prependTo( $( 'div:not(.rollup,.attention,.showHide,.rollupBlock,.column)', local.pagination[posValue].all ));
								}

								if( undefined != response.data.pages && !response.data.pages )
								{
									local.pagination[posValue].first.attr( 'data-active', true ).attr( 'data-hide', true );
									local.pagination[posValue].last.attr(  'data-active', true ).attr( 'data-hide', true );
								}

								// Create link sets from determination
								var removeSet = $( 'a[data-remove]',        local.pagination[posValue].all );
								var hideSet   = $( 'a[data-hide]',          local.pagination[posValue].all );
								var showSet   = $( 'a[data-show]',          local.pagination[posValue].all );
								var activeSet = $( 'a[data-active]',        local.pagination[posValue].all );
								var ellipseL  = $( 'a[data-ellipse-left]',  local.pagination[posValue].all );
								var ellipseR  = $( 'a[data-ellipse-right]', local.pagination[posValue].all );

								$( 'a', local.pagination[posValue].all ).removeAttr( 'data-remove' ).removeAttr( 'data-hide' ).removeAttr( 'data-show' ).removeAttr( 'data-active' ).removeAttr( 'data-ellipse-left' ).removeAttr( 'data-ellipse-right' );

								// After DOM manipulations, set link states
								setTimeout( function( ){
									$( 'a', local.pagination[posValue].all ).removeClass( 'active inactive ellipse-left ellipse-right' );

									local.pagination[posValue].label.removeClass(  'inactive' );
									local.pagination[posValue].select.removeClass( 'inactive' );
									local.pagination[posValue].select.prop( 'disabled', false );

									if( undefined != response.data.pages && !response.data.pages )
									{
										local.pagination[posValue].label.addClass(  'inactive' );
										local.pagination[posValue].select.addClass( 'inactive' );
										local.pagination[posValue].select.prop( 'disabled', true );
									}

									removeSet.addClass( 'inactive'      );
									hideSet.addClass(   'inactive'      );
									activeSet.addClass( 'active'        );
									ellipseL.addClass(  'ellipse-left'  );
									ellipseR.addClass(  'ellipse-right' );

									setTimeout( function( ){
										removeSet.remove( );
									}, 250 );
								}, 100 );
							});

							//Set Status Notifications
							var rollup 		= $( 'div.rollup',local.pagination.upper.all );
							var activeClass = $( 'div.showHide' ).hasClass( 'active' ) ? ' active' : '';
														
							if( 0 != response.data.pages && response.data.statusSet.length && local.settings.admin ) {
								if( !rollup.length ) {
									var     isNew = 1;
									var    rollup = $( '<div />' );
									var attention = $( '<div />' );
									var  showHide = $( '<div />' );
								} else {
									var     isNew = 0;
									var attention = $( 'div.attention', local.pagination.upper.all );
									var showHide  = $( 'div.showHide',  local.pagination.upper.all );

									attention.html( '' );
									 showHide.html( '' );
								}

								var attentionCount = 0;
								var statusCount    = 0;
								var titleLink = '';

								for( var i = 0; i < response.data.statusSet.length; i++ )
									if( response.data.statusSet[i].attention ) attentionCount += 1; else statusCount += 1;

								var columnCount = attentionCount > statusCount ? attentionCount : statusCount;

								for( var i = 0; i < response.data.statusSet.length; i++ ) {
									var attentionClass = !response.data.statusSet[i].count ? '' : 'attention';

									if( attentionClass != '' && response.data.statusSet[i].reference )
										attentionClass += ' reference';

									if(response.data.statusSet[i].filterval == '')
										titleLink = response.data.statusSet[i].title;
									else
										titleLink = '<span class="rollupLink" data-filter="' + response.data.statusSet[i].filter + '" data-filterval="' + response.data.statusSet[i].filterval + '">' + response.data.statusSet[i].title + '</span>';

									if( response.data.statusSet[i].attention )
										$( '<div class = "rollupBlock"><span class = "chevron' + activeClass + '">&raquo;</span><span class = "' + attentionClass + '">' + response.data.statusSet[i].count + '</span>' + titleLink + '</div>' ).appendTo( attention );
									else
										$( '<div class = "rollupBlock"><span>' + response.data.statusSet[i].count + '</span>' + titleLink + '</div>' ).appendTo( showHide );
								} 

								if( isNew ) {
									attention.addClass( 'attention' );
									showHide.addClass(  'showHide' + activeClass );
									rollup.addClass(    'rollup column span_1_2' );

									attention.appendTo( rollup );
									showHide.appendTo(  rollup );

									rollup.prependTo( local.pagination.upper.all );
								}
							} else
								rollup.remove( );

							$( 'tr:not(.header)', local.table ).remove( )
							if( undefined == response.data.recordSet )
								$( '<tr><td colspan = "' + $( 'th, td', local.header ).length + '">A data set could not be retrieved from the server.</td></tr>' ).appendTo( local.table );
							else if( 0 == response.data.pages ) {
								local.settings.hasResults = false;

								if( local.settings.noResultsMsg.length )
									local.noResultMessage = local.settings.noResultsMsg;
								else if( $( '#filters' ).length ) {
									if( local.settings.hasFilter )
										local.noResultMessage = 'No results found. Please try again by changing the filters above.';
									else if( local.settings.addMessage )
										local.noResultMessage = 'To <b>search</b> or <b>add</b> please select from the filters above.';
									else
										local.noResultMessage = 'To <b>search</b> please select from the filters above.';
								} else
									local.noResultMessage = 'No results were found.';

								//No results were found.
								$( '<tr class="noResults"><td colspan = "' + $( 'th, td', local.header ).length + '">' + local.noResultMessage + '</td></tr>' ).appendTo( local.table );
								if( local.settings.addMargin && !local.settings.admin ) local.table.css( 'margin-bottom', '100px' );
								$( 'div', local.pagination.upper.all ).css({ 'margin-top' : 0 });
							}
							else
								for( var i = 0; i < response.data.recordSet.length; i++ ) {
									local.settings.renderer.call( local.table.get( 0 ), response.data.recordSet[i] );
									if( local.settings.lineNumber ) {
										var row = local.table.find( 'tr:last' );
										var cell = row.find( 'td:first' );
										var line = (( response.data.page - 1 ) * response.data.perPage ) + i + 1;
										cell.addClass( 'lineNumber ' ).attr( 'data-row', line );
									}

								}

							local.table.css( 'border-bottom', '' );

							local.table.removeClass( 'network' );

							/* Uhg */
							// if( navigator.userAgent.toLowerCase( ).indexOf( 'firefox' ) > -1 )
							// {
								var tempStyle = local.table[0].getAttribute( 'style' );
								local.table[0].setAttribute( 'style', 'display: none !important' );
								setTimeout( function( ){
									local.table[0].setAttribute( 'style', tempStyle );

									drawResponsiveTable( );
									$( parent ).trigger( 'resize' );
								}, 60 );
							// }
							// else
							// {
							// 	drawResponsiveTable( );
							// }

							setTimeout( function( ) {
								local.settings.onRenderComplete.call( local.table.get( 0 ));
							}, 50 );
							if( local.settings.admin ) setRollup( );
						}
					);
				}

				var intervalRef = setInterval( intervalCall, 500 );
				intervalCall( );
			};

			var drawResponsiveTable = function( )
			{
				if( !local.settings.responsive || local.table.width( ) <= local.table.parent( ).width( ))
				{
					local.table.parent( ).removeClass( 'scrollable' );
					local.responsive.addClass( 'hidden' );
					$( 'tr', local.table ).css( 'height', '' );
					return;
				}

				local.table.parent( ).addClass( 'scrollable' );

				local.responsive.empty( );

				$( 'tr', local.table ).clone( true ).appendTo( local.responsive );

				$( 'th:not(:first-child), td:not(:first-child)', local.responsive ).remove( );

				if(local.settings.hasResults) var responsiveWidth = $( 'th:first-child', local.table ).width( );
										 else var responsiveWidth = local.table.parent( ).width( );

				local.responsive.css( 'width', responsiveWidth + 'px' );
				// local.responsive.css( 'top',   local.table.position( ).top + 'px' );

				var oldCells = $( 'th:first-child, td:first-child', local.table      );
				var newCells = $( 'th:first-child, td:first-child', local.responsive );

				var ua = navigator.userAgent.toLowerCase( );
				var offset = 0;

				for( var i = 0; i < oldCells.length; i++ )
				{
					var oldCell = $( oldCells[i] );
					var newCell = $( newCells[i] );

					oldCell.parent( ).css( 'height', '' );

					newCell.parent( ).css( 'height', ( oldCell.parent( ).outerHeight( ) + 1 ) + 'px' );
					oldCell.parent( ).css( 'height', ( oldCell.parent( ).outerHeight( ) + 1 ) + 'px' );
				}

				local.responsive.attr( 'class', 'isResponsive ' + local.table.attr( 'class' ));
			};

			var setFilters = function( overwrite, sync )
			{
				if( !$( local.settings.filters ).length )
					return;

				if( undefined == sync || true !== sync )
					sync == false;

				var data       = {};
				data.method    = 'setFilters';
				data.overwrite = overwrite;
				data.faytFilterList = '';

				var emptyForm = true;
				$( 'input:not([type="radio"],[type="checkbox"],[type="button"],[type="submit"]), input[type="radio"][checked], input[type="radio"]:checked, input[type="checkbox"][checked], input[type="checkbox"]:checked, select, textarea', $( local.settings.filters )).each( function( ){
					emptyForm = false;
					var element = $( this );

					if( element.is( 'select[placeholder]' ) && !$( 'option[value=""]', element ).length && !element.html( ).match(/<option .*?selected.*?>/gi))
					{
						data[element.attr( 'name' )] = '';
					}
					else if( undefined == data[element.attr( 'name' )])
					{
						if( element.attr( 'placeholder' ) == element.val( ))
							data[element.attr( 'name' )] = '';
						else
							data[element.attr( 'name' )] = element.val( );
					}
					else
					{
						if( element.attr( 'placeholder' ) == element.val( ))
							data[element.attr( 'name' )] &= ',';
						else
							data[element.attr( 'name' )] &= ',' & element.val( );
					}

					if( element.parent( ).hasClass( 'fayt' ) && undefined != element.attr( 'name' ) && !element.attr( 'data-retain' )) {
						if( data.faytFilterList.length == 0 ) data.faytFilterList = element.attr( 'name' );
													else data.faytFilterList += ',' + element.attr( 'name' );
					}
				});

				if( emptyForm )
					return;

				remoteCall(
					data,
					function( response )
					{
						if( !overwrite )
							return;

						highlightPage( 1 );
						highlightSort( 1 );

						remoteCall( { method : 'setPage', page : 1 }, function( ){ /* GNDN */ });
						remoteCall( { method : 'setSort', sort : 1 }, function( ){ /* GNDN */ });

						setResults( 'setFilters' );
					},
					'POST',
					!sync
				);
			};

			var setResults = function( source )
			{
				remoteCall({ method : 'setResults' }, function( ) { getWindow( source ); });
			};

			var setPage = function( )
			{
				if( $( this ).hasClass( 'active' ))
					return;

				var data    = {};
				data.method = 'setPage';
				data.page   = $( this ).attr( 'href' );

				if( '#first' == data.page ) data.page = $( 'a.active:not([href="#first"],[href="#last"])', $( this ).parent( ).parent( )).prev( ).attr( 'href' );
				if(  '#last' == data.page ) data.page = $( 'a.active:not([href="#first"],[href="#last"])', $( this ).parent( ).parent( )).next( ).attr( 'href' );

				$.each( local.pagination.positions, function( posIndex, posValue ){
					$( 'a[href="' + data.page + '"]', local.pagination[posValue].all ).addClass( 'active' );
				});

				data.page = parseInt( data.page.replace( '#', '' ), 10 );

				highlightPage( data.page )

				remoteCall( data );
			};

			var setPerPage = function( )
			{
				var data     = {};
				data.method  = 'setPerPage';
				data.perPage = $( this ).val( );

				$.each( local.pagination.positions, function( posIndex, posValue ){
					if( local.settings.admin )
						local.pagination[posValue].label.text( data.perPage );

					local.pagination[posValue].select.val( data.perPage );
				});

				remoteCall( data );
			};

			var setSort = function( )
			{
				var link = $( this );

				if( link.hasClass( 'active' ))
					return;

				if(link.hasClass('eventSearch')) {
					if( '#swap' == link.attr( 'href' ) && !$( 'a.active[href="#asc"]', link.parent( )).length ) {
						link = $( 'a[href="#asc"]', link.parent( ));
						$( 'a[href="#dsc"]', link.parent( )).attr('style','display:none !important');
						link.attr('style','display:block !important');
					} else if( '#swap' == link.attr( 'href' )) {
						link = $( 'a[href="#dsc"]', link.parent( ));
						$( 'a[href="#asc"]', link.parent( )).attr('style','display:none !important');
						link.attr('style','display:block !important');
					}
				} else {
					if( '#swap' == link.attr( 'href' ) && !$( 'a.active[href="#asc"]', link.parent( )).length )
						link = $( 'a[href="#asc"]', link.parent( ));
					else if( '#swap' == link.attr( 'href' ))
						link = $( 'a[href="#dsc"]', link.parent( ));
				}

				var data    = {};
				data.method = 'setSort';
				data.sort   = link.attr( 'data-sort' );

				highlightSort( data.sort );

				remoteCall( data );
			};

			var highlightPage = function( page )
			{
				$.each( local.pagination.positions, function( posIndex, posValue ){
					var link = $( 'a[href="#' + page + '"]', local.pagination[posValue].all );

					$( 'a.active', local.pagination[posValue].all ).removeClass( 'active' );

					if( link.length )
					{
						var allPages = $( 'a:not([href="#first"],[href="#last"])', local.pagination[posValue].all );

						link.addClass( 'active' );

						if( link.attr( 'href' ) == allPages.first( ).attr( 'href' )) local.pagination[posValue].first.addClass( 'active' );
						if( link.attr( 'href' ) == allPages.last(  ).attr( 'href' )) local.pagination[posValue].last.addClass(  'active' );
					}
				});
			};

			var highlightSort = function( sort )
			{
				$( 'a.active', local.header ).removeClass( 'active' );
				$( 'a[data-sort="' + sort + '"]', local.header ).addClass( 'active' );
			};

			var eventSink = function( evt )
			{
				evt.preventDefault( );

				return;
			};

			var remoteCall = function( data, callback, type, async )
			{
				if( undefined == callback )
					callback = function( ){ setResults( 'remoteCall' ); };

				if( undefined == type || 'POST' != type )
					type == 'GET';

				if( undefined == type || false !== async )
					async = true;

				data.windowID  = local.settings.windowID;
				data.controlID = local.settings.controlID;

				return $.ajax({
					url      : '/cfcs/paginateGW.cfc',
					type     : type,
					async    : async,
					cache    : false,
					dataType : 'json',
					data     : data,
					success  : callback,
					error    : function( jqXHR, textStatus, errorThrown )
					{
						
						var isBeta = window.location.origin.includes("beta");
						
						if( 412 === jqXHR.status && !isBeta )
							location.reload( );
						else if (isBeta)
						{
							displayFailureBanner( 'Communication with the server was not successful.' );
						}	

						// displayFailureBanner( 412 === jqXHR.status ? errorThrown : 'Communication with the server was not successful.' );
					}
				});
			};

			var setTitle = function( element, uuid, type )
			{
				$.ajax({
					url      : '/cfcs/eventGW.cfc',
					cache    : false,
					dataType : 'json',
					data     : {
							method : 'getFAYTSearchAJAX',
							uuid   : uuid,
							type   : type
						},
					success  : function( result ){
						element.siblings( $( 'input[type="text"]' )).val( result );
					}
				});
			}

			// Establish root container
			var local = {};

			// Establish local settings
			local.settings = settings;

			if( !local.settings.filters.length )
				local.settings.filters = '#_';

			// Support for admin override setting
			if( local.settings.admin )
			{
				local.settings.color         = local.settings.color === 'soft-berry' ? local.settings.color : 'blue';
				local.settings.perPage       = [1,10,25,50,100,250];
				local.settings.pagePositions = ['upper'];
				local.settings.responsive    = true;
			}

			// Retrieve and create DOM housekeeping elements
			local.container   = $( this ).parent( );
			local.placeholder = $( '<span />' );
			local.wrapper     = $( '<div  />' );

			// Retrieve and create DOM table elements
			local.table           = $( this );
			local.responsive      = $( '<table />' );
			local.header          = $( 'tr', local.table ).first( );
			local.sortableColumns = [];

			// Insert temporary placeholder
			local.placeholder.insertBefore( local.table );
			local.table.detach(  );
			local.header.detach( );
			local.table.empty(   );

			// Set attributes
			local.table.removeAttr( 'class style' );

			// Set classes
			local.wrapper.addClass(     'paginatedTable' );
			local.table.addClass(   local.settings.color );
			local.header.addClass(              'header' );

			if( local.settings.admin    ) local.wrapper.addClass(   'admin' );
			if( local.settings.subadmin ) local.table.addClass(  'subadmin' );
			if( local.settings.noclick  ) local.wrapper.addClass( 'noclick' );

			// Multiline support
			if( local.settings.admin )
				$( 'th br, td br', local.header ).each( function( ){
					$( this ).parent( ).addClass( 'multiline' );
				});

			// Add sortable chevrons
			if( local.settings.sortable )
			{
				$( 'th[data-sort], td[data-sort]', local.header ).each( function( ){
					var cell      = $( this );
					var titleHTML = cell.html( );
					var titleText = titleHTML.indexOf( '<' ) > -1 ? $.trim( titleHTML.substr(0, titleHTML.indexOf('<'))) : cell.text( );
					var swap      = $( '<a />' );
					var asc       = $( '<a />' );
					var dsc       = $( '<a />' );

					swap.attr( 'href', '#swap' );
					 asc.attr( 'href',  '#asc' );
					 dsc.attr( 'href',  '#dsc' );

					asc.attr( 'data-sort', cell.attr( 'data-sort' ).split( ',' )[0] );
					dsc.attr( 'data-sort', cell.attr( 'data-sort' ).split( ',' )[1] );

					swap.attr( 'title', 'Sort by \'' + titleText + '\'' );
					 asc.attr( 'title', 'Sort by \'' + titleText + '\', ascending'  );
					 dsc.attr( 'title', 'Sort by \'' + titleText + '\', descending' );

					asc.text( '\u25B2' );
					dsc.text( '\u25BC' );

					swap.html( titleHTML );

					cell.empty( );

					if( local.settings.color == 'dkblue eventSearch') {
						swap.addClass('eventSearch');
						asc.addClass('eventSearchAsc');
						dsc.addClass('eventSearchDsc');
						swap.appendTo( cell );
						asc.appendTo(  cell );
						dsc.appendTo(  cell );
					} else {
						asc.appendTo(  cell );
						dsc.appendTo(  cell );
						swap.appendTo( cell );
					}

					local.sortableColumns.push( cell );
				});
			}

			// Sink events
			local.header.on( 'click', 'th[data-sort] a, td[data-sort] a', eventSink );
			$( local.settings.filters ).on( 'submit', eventSink );

			// Bind events
			local.header.on( 'click', 'th[data-sort] a, td[data-sort] a', setSort );

			$( local.settings.filters ).on( 'submit', function( ){
				setFilters( true, false );
			});

			$( 'input[type="button"]', local.settings.filters ).on( 'click', function( evt ){
				evt.stopPropagation( );
				evt.stopImmediatePropagation( );


				var target = $(this).attr('data-target');
				if ( typeof target === "string" && target.length > 0 )
				{
					try {
						$( target, local.settings.filters ).val("");
					}
					finally {
						$( local.settings.filters ).trigger( 'submit' );
					}
				}
				else
				{
					try {
						$( local.settings.filters ).get( 0 ).reset( );
						$( 'input, select', local.settings.filters ).each(function(index, el) {
							try { $(el).trigger( 'reset' ); }
							catch (e) { }
							// $(el).trigger( 'reset' );
						});

						$( '.fayt input[type="hidden"], #prodCode', local.settings.filters ).val('');
					}
					finally {
						$( local.settings.filters ).trigger( 'submit' );
					}
				}


			});

			$( window ).on( 'resize orientationchange', function( ) {
				drawResponsiveTable( );
				if( local.settings.admin ) setRollup( );
			});

			$( 'nav#sidebar a.sidebarMenu' ).click(function(event) {
				setTimeout( function( ) {
					drawResponsiveTable( );
				}, 250 );
			});

			// Pagination support
			local.pagination              = {};
			local.pagination.values       = local.settings.perPage;
			local.pagination.positions    = local.settings.pagePositions;

			$.each( local.pagination.positions, function( posIndex, posValue ){
				// Retrieve and create DOM pagination elements
				local.pagination[posValue]               = {};
				local.pagination[posValue].all           = $( '<div    />' );
				local.pagination[posValue].perPage       = $( '<span   />' );
				local.pagination[posValue].label         = $( '<label  />' );
				local.pagination[posValue].select        = $( '<select />' );
				local.pagination[posValue].first         = $( '<a      />' );
				local.pagination[posValue].last          = $( '<a      />' );
				local.pagination[posValue].modal         = $( '<div    />' );
				local.pagination[posValue].modalControl  = $( '<a      />' );

				for( var i = 0; i < local.pagination.values.length; i++ )
				{
					var option = $( '<option />' );
					option.val(  local.pagination.values[i] );
					option.text( local.pagination.values[i] );

					option.appendTo( local.pagination[posValue].select );
				}

				// Set attributes
				local.pagination[posValue].first.attr( 'title', 'Go to previous page' );
				local.pagination[posValue].last.attr(  'title', 'Go to next page' );
				local.pagination[posValue].first.attr(  'href', '#first' );
				local.pagination[posValue].last.attr(   'href', '#last'  );
				local.pagination[posValue].select.attr(   'id', 'select_' + posValue + '_' + ( new Date( )).getTime( ));
				local.pagination[posValue].label.attr(   'for', local.pagination[posValue].select.attr( 'id' ));

				// Set text
				local.pagination[posValue].label.text( 'Show per page' );
				local.pagination[posValue].first.text( '\u2190' );
				local.pagination[posValue].last.text(  '\u2192' );

				// Set classes
				local.pagination[posValue].all.addClass(          'pagination ' + posValue );
				local.pagination[posValue].first.addClass(        'active inactive' );
				local.pagination[posValue].last.addClass(         'active inactive' );
				local.pagination[posValue].modal.addClass(        'modal' );
				local.pagination[posValue].modalControl.addClass( 'modalControl' );

				// Sink events
				local.pagination[posValue].all.on( 'click', 'a', eventSink );

				// Bind events
				local.pagination[posValue].all.on(     'click', 'a', setPage    );
				local.pagination[posValue].select.on( 'change',      setPerPage );

				// Setup Modal
				// local.pagination[posValue].label.appendTo(  local.pagination[posValue].modal );
				// local.pagination[posValue].select.appendTo( local.pagination[posValue].modal );

				// Append elements
				if( local.settings.admin )
				{
					local.pagination[posValue].select.appendTo( local.pagination[posValue].perPage );
					local.pagination[posValue].label.appendTo(  local.pagination[posValue].perPage );
				}
				else
				{
					local.pagination[posValue].label.appendTo(  local.pagination[posValue].perPage );
					local.pagination[posValue].select.appendTo( local.pagination[posValue].perPage );
				}

				local.pagination[posValue].perPage.appendTo( local.pagination[posValue].all );
				local.pagination[posValue].first.appendTo(   local.pagination[posValue].all );
				local.pagination[posValue].last.appendTo(    local.pagination[posValue].all );

				// local.pagination[posValue].modalControl.appendTo( local.pagination[posValue].all );
				// local.pagination[posValue].modal.appendTo(        local.pagination[posValue].all );

				if( local.settings.admin )
					local.pagination[posValue].all.wrapInner( '<div />' ).wrapInner( '<div class = "column span_1_2 noborder" />' ).addClass( 'admin' );
				else
					local.pagination[posValue].all.wrapInner( '<div />' );
			});

			// Append elements
			local.header.appendTo( local.table   );
			local.table.appendTo(  local.wrapper );

			if( local.settings.responsive )
				local.responsive.appendTo( local.wrapper );

			local.table.wrap( '<div class = "scrollable">' );

			if( local.settings.paginated && undefined != local.pagination.upper ) local.pagination.upper.all.prependTo( local.wrapper );
			if( local.settings.paginated && undefined != local.pagination.lower ) local.pagination.lower.all.appendTo(  local.wrapper );

			if( local.settings.actions.length )
			{
				if( typeof local.settings.actions === 'string' )
				{
					var tempAction = local.settings.actions;
					local.settings.actions = [];
					local.settings.actions.push( tempAction );
				}

				for( var i = local.settings.actions.length - 1; i >= 0; i-- )
				{
					var action = $( local.settings.actions[i] ).filter( 'a' );

					if( action.length )
					{
						action.addClass( 'action' );
						action.removeAttr( 'id' );

						action.clone( ).addClass( 'upper' ).prependTo( local.wrapper );
						action.clone( ).addClass( 'lower' ).insertBefore( local.wrapper.children( ).last( ));
						action.remove( );
					}
				}
			}

			local.wrapper.insertAfter( local.placeholder );

			local.placeholder.remove( );

			if( local.settings.inlineFilters && local.settings.filters.length )
			{
				local.wrapper.addClass( 'inlineFilters' );
				if( local.settings.multiTab ) local.wrapper.addClass( 'multiTab' );
				var setFilterLocation = function( )
				{
					if( !local.settings.paginated || ( undefined != local.pagination.upper.all && 'static' != local.pagination.upper.all.css( 'position' )))
						$( local.settings.filters ).detach( ).insertBefore( local.table.parent( ));
					else
						$( local.settings.filters ).detach( ).prependTo( local.wrapper );
				}

				if( navigator.userAgent.toLowerCase( ).match( /android/ )) $( window ).on( 'orientationchange', 	   setFilterLocation );
																	  else $( window ).on( 'resize orientationchange', setFilterLocation );
				setFilterLocation( );
			}

			setFilters( false, true );

			setResults( 'init' );
		});
	};
})( jQuery );
